var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeModalIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 646,
    height: 290,
    viewBox: "0 0 646 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20C0.5 8.9543 9.45431 0 20.5 0H625.5C636.546 0 645.5 8.95431 645.5 20V290H0.5V20Z",
    fill: "#2648B2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 212.326,
    width: 645,
    height: 77.6743,
    fill: "#008180"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M461.568 290H182.183V177.866L224.235 114.67H419.516L461.568 177.866V290Z",
    fill: "#8E7EAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.287 290H182.183V177.866L224.235 114.67L266.287 177.866V290Z",
    fill: "#0C1F28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M266.286 177.866H461.568L419.516 114.67H224.234L266.286 177.866Z",
    fill: "#BAA7C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.234 187.008C230.597 187.008 235.755 181.85 235.755 175.487C235.755 169.124 230.597 163.966 224.234 163.966C217.871 163.966 212.713 169.124 212.713 175.487C212.713 181.85 217.871 187.008 224.234 187.008Z",
    fill: "#F0E221"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.968 211.128H209.508V251.987H238.968V211.128Z",
    fill: "#F0E221"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M322.353 211.128H292.893V251.987H322.353V211.128Z",
    fill: "#F0E221"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M434.724 211.128H405.264V251.987H434.724V211.128Z",
    fill: "#F0E221"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M245.287 124.684H413.84L441.54 166.422H272.988L245.287 124.684Z",
    fill: "#0C1F28",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M259.141 145.553H427.694",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M357.658 124.684L385.358 166.422",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M301.477 124.684L329.177 166.422",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M363.687 211.128C371.818 211.128 378.413 217.73 378.413 225.855V290H348.953V225.855C348.953 217.723 355.555 211.128 363.679 211.128H363.687Z",
    fill: "#0C1F28"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M202.371 262.567H215.054C220.103 262.567 224.234 258.436 224.234 253.387V240.742C224.234 235.693 227.547 231.562 231.601 231.562H238.968",
    stroke: "#FF0080",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M233.659 290H204.023C203.977 289.51 203.947 289.013 203.947 288.508C203.947 280.193 210.686 273.445 219.01 273.445C223.523 273.445 227.57 275.434 230.332 278.578C230.301 278.074 230.286 277.569 230.286 277.056C230.286 262.422 242.151 250.549 256.793 250.549C267.526 250.549 276.759 256.929 280.929 266.109C284.593 263.072 289.29 261.251 294.416 261.251C304.529 261.251 312.975 268.35 315.071 277.829C317.794 275.113 321.55 273.438 325.697 273.438C334.012 273.438 340.759 280.177 340.759 288.5C340.759 289.005 340.736 289.503 340.683 289.992H314.168H310.71H279.919H274.663H233.988",
    fill: "#008180"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M192.717 282.702V273.537H202.371V251.589H192.717V242.425C192.717 238.416 189.817 235.126 186.298 235.126H101.383C96.5791 235.126 92.624 238.416 92.624 242.425V282.648C92.624 286.71 96.5791 290 101.383 290H186.298C189.825 290 192.717 286.71 192.717 282.702Z",
    fill: "#5CA19A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.582 247.298H151.69L144.414 260.02H151.69L138.998 279.183V264.816H133.582V247.305V247.298Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.624 131.34C138.914 131.34 135.732 133.566 134.324 136.756C132.656 131.431 127.692 127.56 121.816 127.56C115.941 127.56 111.29 131.179 109.477 136.243C107.044 124.286 96.472 115.282 83.7959 115.282C71.1199 115.282 61.0065 123.904 58.2831 135.478C55.9193 127.821 48.7818 122.259 40.3515 122.259C30.3836 122.259 22.2363 130.031 21.6167 139.846H151.69C151.391 135.096 147.452 131.34 142.624 131.34Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M503.375 131.34C507.086 131.34 510.268 133.566 511.676 136.756C513.343 131.431 518.308 127.56 524.183 127.56C529.867 127.56 534.71 131.179 536.523 136.243C538.955 124.286 549.528 115.282 562.204 115.282C574.612 115.282 584.993 123.904 587.717 135.478C590.08 127.821 597.218 122.259 605.648 122.259C615.616 122.259 623.763 130.031 624.383 139.846H588.367H586.913H537.265H536.041H512.433H511.102H494.31C494.608 135.096 498.548 131.34 503.375 131.34Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeModalIllustration);
export default __webpack_public_path__ + "static/media/welcome-modal-illustration.732db14eba4564e1e100288ed2077370.svg";
export { ForwardRef as ReactComponent };